let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("gBafa")]).then(() => parcelRequire('3cTdW'));